// zod v4 probes `new Function('')` once (cached) to decide whether it can use
// a JIT-compiled fast path for schema validation. Our CSP has no
// 'unsafe-eval', so the probe throws; zod catches it and falls back to the
// interpreted validator (functionally harmless), but the browser still
// reports a securitypolicyviolation for the swallowed throw (AB#1600). zod's
// own `jitless` flag skips the probe entirely instead of widening the CSP.
//
// This seeds zod's global config object directly instead of calling
// `z.config()`, so the entry chunk does not import zod (every schema lives in
// lazy chunks; AB#1790). It relies on zod's internal global name
// `__zod_globalConfig`; zodGlobalConfig.test.ts pins it and fails on a rename.
//
// Bundling inlines this into the entry chunk's body, which runs after the entry's
// static imports. A zod object schema built at module scope in an eager module
// would probe before this line, exactly as with the z.config() call it replaces;
// keep zod schemas out of eagerly loaded modules.
import type { $ZodConfig } from 'zod/v4/core'

const scope = globalThis as typeof globalThis & { __zod_globalConfig?: Partial<$ZodConfig> }

scope.__zod_globalConfig ??= {}
scope.__zod_globalConfig.jitless = true
